import { Route, Routes } from "react-router-dom";
import AddUser from "./add-users/add-users.component";
import ListUsers from "./list-users/list-users.component";
import ListUserRepairRecords from "./list-user-repair-records/list-user-repair-records.component";
import { GetUserBalanceByIdPage } from "../../pages/user/get-user-balance-by-id.page";
import { UpdateUserByIdPage } from "../../pages/user/update-user-by-id.page";
import { InviteUserByEmailPage } from "../../pages/user/invite-user-by-email.page";
import { ACCESS_RULES } from "../../shared/auth/access-control";
import RoleProtectedRoute from "../protected/role-protected-route.component";

const UsersRoutes = () => {
  return (
    <Routes>
      {/* <Route path="/add" element={<AddUser />} /> */}
      <Route path="/add" element={<RoleProtectedRoute allowedRoles={ACCESS_RULES.USERS}><InviteUserByEmailPage /></RoleProtectedRoute>} />
      <Route path="/list" element={<RoleProtectedRoute allowedRoles={ACCESS_RULES.USERS}><ListUsers /></RoleProtectedRoute>} />
      <Route path="/:userId/balance" element={<RoleProtectedRoute allowedRoles={ACCESS_RULES.USERS}><GetUserBalanceByIdPage /></RoleProtectedRoute>} />
      <Route path="/:userId/update" element={<RoleProtectedRoute allowedRoles={ACCESS_RULES.USERS}><UpdateUserByIdPage /></RoleProtectedRoute>} />
      <Route path="/repair-records/:userID" element={<RoleProtectedRoute allowedRoles={ACCESS_RULES.USERS}><ListUserRepairRecords /></RoleProtectedRoute>} />
    </Routes>
  );
};

export default UsersRoutes;
